import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

type Tone = 'default' | 'error';
interface ToastItem {
  id: number;
  msg: string;
  tone: Tone;
}
type ShowToast = (msg: string, tone?: Tone) => void;

const ToastContext = createContext<ShowToast>(() => {});
let counter = 0;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const dismiss = useCallback((id: number) => setToasts((t) => t.filter((x) => x.id !== id)), []);
  const show = useCallback<ShowToast>(
    (msg, tone = 'default') => {
      const id = ++counter;
      setToasts((t) => [...t, { id, msg, tone }]);
      // Errors linger longer — they report a failure the user may need to act on.
      setTimeout(() => dismiss(id), tone === 'error' ? 6000 : 2600);
    },
    [dismiss],
  );
  return (
    <ToastContext.Provider value={show}>
      {children}
      {/* announced to screen readers; polite for success, the alert role escalates errors */}
      <div className="toast-wrap" aria-live="polite">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={t.tone === 'error' ? 'toast toast-error' : 'toast'}
            role={t.tone === 'error' ? 'alert' : 'status'}
            onClick={() => dismiss(t.id)}
            title="بستن"
          >
            {t.msg}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast(): ShowToast {
  return useContext(ToastContext);
}
